<template>
  <div>
    <main>
      <CxAboutUs />
      <CxPromos />
    </main>
    
  </div>
</template>

<script>
import CxAboutUs from "@/components/CxAboutUs.vue";
import CxPromos from "@/components/CxPromos.vue";

export default {
  components: {
    CxAboutUs,
    CxPromos,
  }
};
</script>


